<template>
	<!-- Section 1 -->
	<div class="card mb-4" style="width:100%">
		<div class="card-header" v-if="instanceClassAttr.typeItems != 'itemsInit'">
			<div align="right">
				<b-button v-if="instanceClassAttr.actCol.actPrint" id="print" variant="primary"
					class="btn btn-info btn-sm" type="button" @click="produce()">
					<fa icon="print"/>
						&nbsp;
						{{this.$t('dataTable.print')}}
				</b-button>
				<modal-pdf-viewer 
					ref="componentModalPdf" 
					:pdfSrc="pdfSrc"
					:pdfName="pdfName"
				/>
			</div>
		</div>
		<div class="card-body">
			<div class="overflow-auto">
				<div v-show="!instanceClassAttr.items" class="form-row" style="margin: 0 -5px">
					<div class="col-md-4">
						<b-form-input v-model="filter" :placeholder="$t('vtabTrans.filterPlaceholder')" />
					</div>
					<div class="col-md-6"></div>
					<div class="col-md-2">
						<b-form-select class="numPerPage" size="sm" v-model="perPage" :options="pageOptions" @change="onChangePerPage">
						</b-form-select>
					</div>
					
				</div>
				<br>
				<div class="dataTable-wrapper dataTable-loading no-footer fixed-columns table-responsive">
					<b-table
						ref="myTable"
						responsive="sm" 
						striped bordered small hover
						:fields="fields" 
						:items="items"
						:current-page="currentPage"
					>
					<!-- :sort-desc="sortDesc"
					sort-by="prsTeamLib" -->
					
					<template #cell(servOp)="props">
						<!-- <div v-if="msgError" class="alert alert-danger" role="alert" v-html="msgError" /> -->
						<!-- {{servOpDetails(props.item.servOp)}} -->
						<div class="text-center">
							<h5>
								<b-badge 
									v-for="detailsOp in servDetails(props.item)" :key="detailsOp" 
									variant="info" class="ml-1">
									{{detailsOp}}
								</b-badge>
							</h5>
						</div>
					</template>

					<template #cell(prodOrderItem)="props">
						<div class="text-center">
							<h5>
								<b-badge 
									v-for="orderItem in props.item.prodOrderItem" :key="orderItem" 
									variant="info" class="ml-1">
									{{orderItem.lib}}
								</b-badge>
							</h5>
						</div>
					</template>

					<!-- FORMAT NUMBER -->
					<template #cell(stock)="props">
						{{$store.getters.formatNumber(props.item.stock)}}
					</template>
					<template #cell(quantity)="props">
						{{$store.getters.formatNumber(props.item.quantity)}}
					</template>

					<!-- FORMAT Double -->
					<template #cell(cost)="props">
						{{$store.getters.formatAmount(props.item.cost)}}
					</template>
					<template #cell(amount)="props">
						{{$store.getters.formatAmount(props.item.amount)}}
					</template>
					<template #cell(mvtAmount)="props">
						{{$store.getters.formatAmount(props.item.mvtAmount)}}
					</template>

					<template #cell(mvtSolde)="props">
						<b>
							<FONT v-if="props.item.mvtSolde > 0" color="green">
								{{$store.getters.formatAmount(props.item.mvtSolde)}}
							</FONT>
							<FONT v-if="props.item.mvtSolde < 0" color="#C50E0E">
								{{$store.getters.formatAmount(props.item.mvtSolde)}}
							</FONT>
							<FONT v-if="props.item.mvtSolde == 0">
								{{$store.getters.formatAmount(props.item.mvtSolde)}}
							</FONT>
						</b>
					</template>

					<template #cell(solde)="props">
						<!-- {{$store.getters.formatAmount(props.item.solde)}} -->
						<b>
							<FONT v-if="props.item.solde > 0" color="green">
								{{$store.getters.formatAmount(props.item.solde)}}
							</FONT>
							<FONT v-if="props.item.solde < 0" color="#C50E0E">
								{{$store.getters.formatAmount(props.item.solde)}}
							</FONT>
							<FONT v-if="props.item.solde == 0">
								{{$store.getters.formatAmount(props.item.solde)}}
							</FONT>
						</b>
					</template>

					<template #cell(accountTot)="props">
						<!-- {{$store.getters.formatAmount(props.item.accountTot)}} -->
						<b>
							<FONT v-if="props.item.accountTot > 0" color="green">
								{{$store.getters.formatAmount(props.item.accountTot)}}
							</FONT>
							<FONT v-if="props.item.accountTot < 0" color="#C50E0E">
								{{$store.getters.formatAmount(props.item.accountTot)}}
							</FONT>
							<FONT v-if="props.item.accountTot == 0">
								{{$store.getters.formatAmount(props.item.accountTot)}}
							</FONT>
						</b>

					</template>
					<template #cell(amountDebit)="props">
						<FONT color="#C50E0E">
							{{$store.getters.formatAmount(props.item.amountDebit)}}
						</FONT>
					</template>
					<template #cell(amountCredit)="props">
						<FONT color="green"> 
							{{$store.getters.formatAmount(props.item.amountCredit)}}
						</FONT>
					</template>
					<template #cell(payAmount)="props">
						{{$store.getters.formatAmount(props.item.payAmount)}}
					</template>
					<template #cell(paySolde)="props">
						{{$store.getters.formatAmount(props.item.paySolde)}}
					</template>
					<template #cell(lastSolde)="props">
						{{$store.getters.formatAmount(props.item.lastSolde)}}
					</template>
					<template #cell(newSolde)="props">
						{{$store.getters.formatAmount(props.item.newSolde)}}
					</template>
					<template #cell(profit)="props">
						<b>
							<FONT v-if="props.item.profit > 0" color="green">
								{{$store.getters.formatAmount(props.item.profit)}}
							</FONT>
							<FONT v-if="props.item.profit < 0" color="#C50E0E">
								{{$store.getters.formatAmount(props.item.profit)}}
							</FONT>
							<FONT v-if="props.item.profit == 0">
								{{$store.getters.formatAmount(props.item.profit)}}
							</FONT>
						</b>
					</template>
					<template #cell(amountTot)="props">
						{{$store.getters.formatAmount(props.item.amountTot)}}
					</template>
					<template #cell(amountRefund)="props">
						{{$store.getters.formatAmount(props.item.amountRefund)}}
					</template>

					<!-- FORMAT DATE -->
					<template #cell(dateCreated)="props">
						{{$moment(props.item.dateCreated).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(lastUpdated)="props">
						{{$moment(props.item.lastUpdated).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(dateOp)="props">
						{{$moment(props.item.dateOp).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(servDate)="props">
						{{$moment(props.item.servDate).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(orderDate)="props">
						{{$moment(props.item.orderDate).format($store.getters.formatDate)}}
					</template>
					
					<template #cell(mvtDate)="props">
						{{$moment(props.item.mvtDate).format($store.getters.formatDate)}}
					</template>
					<template #cell(dateStart)="props">
						{{$moment(props.item.dateStart).format($store.getters.formatDate)}}
					</template>
					<template #cell(dateEnd)="props">
						{{$moment(props.item.dateEnd).format($store.getters.formatDate)}}
					</template>

					<template #cell(payDate)="props">
						{{$moment(props.item.payDate).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(payDateStart)="props">
						{{$moment(props.item.payDateStart).format($store.getters.formatDateShort)}}
					</template>
					<template #cell(payDateEnd)="props">
						{{$moment(props.item.payDateEnd).format($store.getters.formatDateShort)}}
					</template>

					<template #cell(actions)="props" v-if="instanceClassAttr.actCol.actDisplay">
						
						<!-- <router-link 
							v-if="instanceClassAttr.actCol.actGet"  
							:to="{ name: 'servteamop', params: {itemId:props.item.id} }">
						</router-link> -->

						<b-button ref="show-row" @click="showModal(props.item.id, 'show')"
							class="btn btn-datatable btn-icon btn-info mr-2" id="show-row" v-if="instanceClassAttr.actCol.actGet">
							<fa icon="info-circle"/>
						</b-button>
						<b-button ref="edit-row" @click="showModal(props.item.id, 'edit')"
							class="btn btn-datatable btn-icon btn-success mr-2" id="edit-row" v-if="instanceClassAttr.actCol.actEdit">
							<fa icon="edit"/>
						</b-button>
						<b-button ref="add-row" 
							@click="showModalInstance(props.item, 'add')"
							class="btn btn-xs btn-success mr-2" id="add-row" 
							v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'servtypeserv'
							&& props.item.servService.serviceCode === 'S'
							&& props.item.servType.servCategory.categoryCode === 'ART' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_STOCK'])"
							>
							<fa icon="plus-circle"/> E
						</b-button>
						<!-- &ensp; -->
						<b-button ref="add-row" 
							@click="showModalInstance(props.item, 'minus')"
							class="btn btn-xs btn-danger mr-2" id="add-row" 
							v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'servtypeserv'
							&& props.item.servService.serviceCode === 'S'
							&& props.item.servType.servCategory.categoryCode === 'ART' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_STOCK'])"
							>
							<fa icon="minus-circle"/> S
						</b-button>
						<!-- Remboursement EP & JL -->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && ['EP', 'JL'].includes(props.item.prsPerson.prsType.typeCode)
							&& $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-success btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:1, typeDep:11, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="plus-circle"/> &nbsp;
							RB
						</router-link>
						<!-- &ensp; -->
						<!-- Reglement CL-->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && props.item.prsPerson.prsType.typeCode == 'CL'
							&& $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-success btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:1, typeDep:9, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="plus-circle"/> &nbsp;
							RG
						</router-link>
						<!-- &ensp; -->
						<!-- Autres que EP, JL, CL-->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && props.item.prsPerson.prsType.typeCode == 'FR'
							&& $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-success btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:1, typeDep:NaN, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="plus-circle"/> &nbsp;
							C
						</router-link>
						<!-- &ensp; -->
						
						<!-- EMPRUNT JL, CL-->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && ['EP', 'JL'].includes(props.item.prsPerson.prsType.typeCode)
							&& $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-danger btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:10, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="minus-circle"/> &nbsp;
							EM
						</router-link>
						<!-- &ensp; -->
						<!-- Autres que EP, JL, CL-->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && props.item.prsPerson.prsType.typeCode == 'FR'
							&& $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-danger btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:NaN, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="minus-circle"/> &nbsp;
							D
						</router-link>
						<!-- &ensp; -->
						<!-- VCC -->
						<router-link v-if="instanceClassAttr.actCol.actAdd && instanceClassAttr.instanceClass == 'mvtaccount' && props.item.prsPerson.prsType.typeCode == 'FR' &&!props.item.prsPerson.prsStore && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-primary btn-xs mr-2" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:6, accId:props.item.id, typeAdd: 'one'} }">
							<fa icon="exchange"/> &nbsp;
							V
						</router-link>
						
					</template>
					<!-- <template #cell(actions)="props">
						
					</template> -->
					</b-table>
				</div>
				<div class="mt-3">
					<!-- align="fill/center"  align="center"-->
					<b-pagination v-show="!instanceClassAttr.items" @page-click="onPageClick"
						:total-rows="totalRows"
						v-model="currentPage"
						:per-page="perPage"
						style="max-width:50%"
						class="my-1"
						aria-controls="my-table"
						size="sm"
						>
					</b-pagination> 
					<div class="description found" align="right" style="margin-top: -2%">
						{{totalRowsText}}
					</div>
				</div>


			</div>
		</div>


	</div>
	<!-- Modal Component -->
	<modal-component ref="componentModal"
		:instanceClass="instanceClassAttr.instanceClass"
		:modalType="this.selectedModalType"
		:itemId="this.selectedItemId"
		:attrTrans="attrTrans"
		@refreshDataTable="refreshDataTable"
	/>

	<!-- ModalInstance  -->
	<div v-if="instanceClassAttr.instanceClass == 'servtypeserv'" ref="modalInstance" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-dialog-centered modal-lg"
			role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" v-if="modalType == 'NEW'">
						{{ $t('default.new') }}
					</h5>
					<h5 class="modal-title" v-if="modalType == 'EDIT'">
						{{ $t('default.edit') }}
					</h5>
					<b-button type="button" variant="close" @click="modalToggle()" />
				</div>
				<div class="modal-body">
					<b-container>
						<form role="form" id="modalFormInst" @submit.prevent="axiosPost">
							<div class="row d-flex justify-content-center ">
								<div class="col-md-8">
									<div class="form-group">
										<label>
											{{ $t(instanceClassAttr.instanceClass+'.servTypeStockES')}}
										</label>
										<select v-model="instanceModal.servTypeStockES.id" class="form-control" required="true" readonly="true">
											<option v-for="servTypeStockES in instanceModal.servTypeStockESList" :value="servTypeStockES.id" :key="servTypeStockES.id">
											{{ servTypeStockES.lib}} | {{instanceModal.stock}}
											</option>
										</select>										
									</div>
								</div>
								<div class="col-md-4">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.cost')}}
									</label>
									<input type="number" step="any" v-model="instanceModal.cost" class="form-control" required="true" readonly="true" />
								</div>
								<div class="col-md-3">
									<label>En Stock</label>
									<input type="number" v-model="instanceModal.inStock"
										class="form-control input-valeur" disabled />
								</div>
								<div class="col-md-5">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
									</label>
									<input type="number" v-model="instanceModal.quantity" min="0" :max="instanceModal.quantityMax" class="form-control" required/>
								</div>
								<div class="col-md-4">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.dateOp')}}
									</label>
									<!-- {{instanceModal.dateOp}}
									{{$moment(instanceModal.dateOp).format($store.getters.formatDateShort)}} -->
									<input type="date" v-model="instanceModal.dateOp" class="form-control" required="true" />
								</div>
								

							</div>
						</form>
					</b-container>
					

				</div> <!-- modal-body  -->
				<div class="modal-footer">
					<div class="row d-flex justify-content-end mb-3">
						<!-- <input type="hidden" id="id" name="id" :value="user.id" required> -->

						<!-- INFO v-if="!dataMapShow.readOnlyShow" -->
						<div class="mr-3">
							<button class="btn btn-success" :disabled="loading" @click="axiosPost">
								<fa icon="check"/>
								<span v-show="loading" class="spinner-border spinner-border-sm"/>
								<!-- v-if="!dataMapShow.infos.id" -->
								<span >
									{{ $t('default.button.create') }}
								</span>
								<!-- <span v-if="dataMapShow.infos.id">
									{{ $t('default.button.update') }}
								</span> -->
							</button>
						</div>
						<button type="button" class="btn btn-danger ml-1" @click="modalToggle()">
							<fa icon="times"/>
							{{ $t('default.button.cancel') }}
						</button>
					</div>
				</div> 


			</div> <!-- modal-content  -->
		</div> <!-- modal-dialog  -->
	</div> <!-- ModalInstance  -->

</template>
<script>
	import Modal from '@/components/templates/Modals/Modal.vue'
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'	
	export default {
		name: 'datatable-instance',
		components: {
			'modal-component': Modal,
			'modal-pdf-viewer': ModalPdfViewer
		},
		// mixins: [],
		props: {
			// headerParams: {
			// 	type: Object,
			// 	required: true
			// },
			instanceClassAttr: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
	
				filter:'',
				totalRows: 0,
				perPage: 10,
				currentPage: 1,
				sortBy: "name",
				sortDesc: false,
				/* Number.MAX_SAFE_INTEGER = 9007199254740991 */
				pageOptions: [5, 10, 20, 50, 100, 500, 1000, 10000, {
					value: Number.MAX_SAFE_INTEGER,
					text: "show all"
				}],
				strParamsForms: '',
				fields: [],
				items: [],
				allItems: [],
				itemsInit: [],

				attrTrans: null,
				attrsRepList:[],
				attrsRepLibList:[],

				selectedItemId: NaN,
				selectedModalType: 'new',

				// AJOUT STOCK
				instanceModal: {
					servTypeStockES:{}
				},
				active: false,
				modalType: 'NEW',
				loading: false,
				pdfSrc:'',
				pdfName:'list'
					
			}
		},
		computed: {
			totalRowsText () {
				// let from = this.currentPage
				let from = ((this.currentPage-1) * this.perPage)+1
				let to = this.currentPage * this.perPage
				if(to > this.totalRows)
					to = this.totalRows
				let strTotalRows = this.$t('vtabTrans.showing') + ' '+ from + ' ' + this.$t('vtabTrans.to') + '  '+ to + ' ' + this.$t('vtabTrans.of')
				if(this.totalRows > 1)
					strTotalRows = strTotalRows+ ' '+ this.totalRows+ '  ' +this.$t('vtabTrans.records')
				else
					strTotalRows = strTotalRows +' '+this.$t('vtabTrans.one.record')
				return strTotalRows
			},
		},
		watch: {
			filter: function (newVal) {
				//if(newVal.length >= 2)
				if(this.instanceClassAttr.typeItems != 'itemsInit')
					this.getDataByCriteria()
			}
		},
		created() {
			for(let i = 0; i < this.instanceClassAttr.attrsList.length; i++) {
				if(this.instanceClassAttr.attrsList[i].attrImport !== true){
					let columnHeader = this.instanceClassAttr.attrsList[i].attrLabel?this.instanceClassAttr.attrsList[i].attrLabel:this.instanceClassAttr.attrsList[i].attrName; 
				
					let field = {}
					field.key = this.instanceClassAttr.attrsList[i].attrName;
					if(this.instanceClassAttr.attrsList[i].attrTrans === true){
						this.attrTrans = this.instanceClassAttr.attrsList[i].attrName
						field.key = 'attrTrans'
					}
					// Ignore suf Lib à la fin pour label
					if(columnHeader != null && columnHeader.length > 3 &&  columnHeader.substring(columnHeader.length-3) === "Lib")
						columnHeader = columnHeader.substring(0,columnHeader.length-3)
					field.label = this.$t(this.instanceClassAttr.instanceClass + '.' + columnHeader);
					
					// new 
					field.thStyle = {width:  this.instanceClassAttr.attrsList[i].attrCol};
					field.sortable = this.instanceClassAttr.attrsList[i].sortable
					this.fields.push(field)

					// new, Default true
					if(this.instanceClassAttr.attrsList[i].attrRep && this.instanceClassAttr.attrsList[i].attrRep != false){
						this.attrsRepList.push(this.instanceClassAttr.attrsList[i].attrRep)
						this.attrsRepLibList.push(field.label)
					}
					else if(this.instanceClassAttr.attrsList[i].attrRep != false){
						this.attrsRepList.push(this.instanceClassAttr.attrsList[i].attrName)
						this.attrsRepLibList.push(field.label)
					}

					// console.log('this.attrsRepList == ', this.attrsRepList)
				
				}
			}
			if(this.instanceClassAttr.actCol.actDisplay)
				this.fields.push( { key: 'actions', label: this.$t('default.actions'), thStyle: {width:this.instanceClassAttr.actCol.thCol }  })
			if(this.instanceClassAttr.typeItems != 'itemsInit')
				this.getDataByCriteria();
		},

		methods: {
			servDetails(propsItem){
				let details = []//''
				if(propsItem){
					if(propsItem.servOp && Array.isArray(propsItem.servOp) && propsItem.servOp.length > 0){
						propsItem.servOp.forEach ( serv => {
							let strServOp = serv?.servTypeStockES?.servType?.typeName
							strServOp = strServOp + ' | '+serv?.quantity + ' '+serv?.servTypeStockES?.servType?.servUnitLib
							
							if(this.instanceClassAttr.instanceClass != 'servorder')
								details.push(strServOp)
							else if(this.instanceClassAttr.instanceClass == 'servorder' && serv?.servTypeStockES?.servService?.serviceCode == 'S' )
								details.push(strServOp)

						})
					}
					else if(propsItem.servTypeLib && propsItem.servTypeLib.length > 0) {
						details = propsItem.servTypeLib.split("-")
					}
				}
				return details
			},
			showModal(id, type) {
				this.selectedItemId = id;
				this.selectedModalType = type;
				if(this.instanceClassAttr.routerShow && this.instanceClassAttr.routerShow != ""){
					// this.$router.push('/servteam/show/'+id)
					this.$router.push({ name: this.instanceClassAttr.routerShow, params: { itemId: id } })
				}
				else
					this.$refs.componentModal.modalToggle();
			},
			refreshDataTable(items){
				if(this.instanceClassAttr.typeItems == 'itemsInit'){
					this.itemsInit = items
					this.totalRows = this.itemsInit.length
				}
				this.getDataByCriteria()
			},

			getRows(){
				return this.items;
			},
			getNestedValue (obj, path) {
				return path.split('.').reduce((acc, part) => acc && acc[part], obj);
			},
			drawChart(attrKey, attrValue, items) {
				var dataList = [];
				let dataMap = {}
				if(!items)
					items = this.items
				if(this.allItems && this.allItems.length > 0)
					items = this.allItems
				// console.log('avant parcour avec items = ', items.length )
			
				items?.forEach(item => {
					item[attrValue]
					if(dataMap[this.getNestedValue(item, attrKey)]){
						if(attrValue == 1)
							dataMap[this.getNestedValue(item, attrKey)] = (dataMap[this.getNestedValue(item, attrKey)] + 1)
						else
							dataMap[this.getNestedValue(item, attrKey)] = (dataMap[this.getNestedValue(item, attrKey)] + item[attrValue])
						
					}
					else{
						if(attrValue == 1)
							dataMap[this.getNestedValue(item, attrKey)] = 1
						else
							dataMap[this.getNestedValue(item, attrKey)] = item[attrValue]
					}
				})
				Object.entries(dataMap).forEach(data => {
					dataList.push(data)
				});
				return dataList
			},

			getAllRows(){
				let strParams = "typeRender=list"
				strParams = strParams+ this.strParamsForms
				this.$store.dispatch('axiosGet', { 
					url: '/api/'+this.instanceClassAttr.instanceClass+'/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data && Array.isArray(response.data)){
						this.allItems = response.data
						this.$emit('refreshChart', null);
						/*this.$store.dispatch('showToast', {
							type: 'success', message: this.$t('toast.finished.message')
						});*/
						this.$store.dispatch('unloading')		

					}
					
				})
				.catch(error => {
					console.log('error catch search == ', error.message)
				})
			},
			getAllItems(){
				return this.allItems;
			},
			setStrParamsForms(strParamsForms){
				this.strParamsForms = strParamsForms;
				// init paginate
				this.perPage = 10;
				this.currentPage = 1;
			},
			// strParamsForms = ""
			async getDataByCriteria(typeRender) {
				this.$store.dispatch('loading', this.$t('toast.loading.message'))
				if(this.instanceClassAttr.items){
					this.items = this.instanceClassAttr.items;
					this.totalRows = this.instanceClassAttr.items.length
				}
				else if(this.instanceClassAttr.typeItems == 'itemsInit'){
					let endList = this.currentPage * this.perPage
					let startList = endList - this.perPage
					this.items = this.itemsInit.filter((element, index) => index >= startList && index < endList );
				}
				else {
					let strParams = "typeRender=datatable"//+typeRender
					//Max
					strParams = strParams+"&length="+this.perPage
					//Offset
					let start = 0;
					if(this.currentPage !== 0)
						start = (this.currentPage-1) * this.perPage;
					strParams = strParams+"&start="+start
					strParams = strParams+ this.strParamsForms// strParamsForms
					await this.$store.dispatch('axiosGet', { 
						url: '/api/'+this.instanceClassAttr.instanceClass+'/getbycriteria?' + strParams
					})
					.then(response => {
						if(response.data){
							if(response.data.rows){
								this.items = response.data.rows;
								this.totalRows = response.data.recordsFiltered
							}
							else if(Array.isArray(response.data)){
								this.items = response.data
								this.totalRows = this.items.length
							}
							this.$nextTick(function () {
								this.$emit('refreshChart', null);
								// this.$emit('refreshChart', this.items );
							});
						}
					})
					.catch(error => {
						console.log('error catch search == ', error.message)
					})
					if(typeRender == 'list')
						this.getAllRows()
				}
				this.$store.dispatch('unloading')
			},
			onChangePerPage(val) {
				let isAll = false
				if(val == Number.MAX_SAFE_INTEGER){
					val = this.totalRows;
					// new
					this.getAllRows();
					this.$store.dispatch('loading', this.$t('toast.loading.message'))
					/*this.$store.dispatch('showToast', {
						type: 'warning', message: this.$t('toast.loading.message')
					});*/
				}
				this.perPage = val;

				/*if(isAll){
					let delais = 6000
					let timerId = setTimeout(() => {
						console.log(` ${delais} sec écoulé avec `, this.allItems.length )
						this.$emit('refreshChart', null);
					}, delais);
				}*/
				// a revoir si toute la liste on ne fera datatable
				if(!isAll) 
					this.getDataByCriteria();
			},
			onPageClick(event, page) {
				this.currentPage = page
				this.getDataByCriteria();
			},
			// AJOUT STOCK 
			initInstanceModal(){
				this.instanceModal = {
					servTypeStockESList: [],
					servTypeStockES:{},
					quantity: 0,
					quantityMax:'',
					stock:0,
					cost: '',
					dateOp: new Date(),
					username: this.$store.getters.username
				}
			},
			async showModalInstance(obj, type) {
				// this.selectedItemId = id;
				// this.selectedModalType = type;
				this.initInstanceModal()
				this.instanceModal.inStock = obj?.stock
				// cas d'ajout ou sorti du stock
				// GET LIST servTypeList
				let strParams = "typeRender=list"
				// Get de servtypestockes
				strParams = strParams+"&params1=servType.id&valParams1="+ obj?.servType.id +"&logParams1=eqL"
				strParams = strParams+"&params2=servService.id&valParams2="+ obj?.servService.id +"&logParams2=eqL"
				let idTypeES = 1
				if(type === 'minus'){
					idTypeES = 2
					this.instanceModal.quantityMax = obj?.stock
				}
				strParams = strParams+"&params3=servTypeES.id&valParams3="+ idTypeES +"&logParams3=eqL"

				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtypestockes/getbycriteria?' + strParams
				})
				.then(response => {
					this.instanceModal.servTypeStockESList = response.data
					this.instanceModal.servTypeStockES = this.instanceModal.servTypeStockESList[0]
					this.instanceModal.cost = this.instanceModal.servTypeStockES?.cost 
				})
				.catch(error => {
					console.log('error catch servtypestockes == ', error.message)
				})

				this.modalToggle(type);
			},
			modalToggle(type) {
				this.modalType = type
				if(this.active)
					this.active = false
				else{
					this.active = true
					this.$nextTick(function(){
						// this.axiosShow(this.modalType)
					});
				}
			},
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'servop',
						data: this.instanceModal
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.refreshDataTable('')
						this.$nextTick(() => {
							let msg = this.$t("servop.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				/*let	detailsTop = '';
				let	detailsBot = '';
				let	detailsBotC1 = '';
				let	detailsBotC2 = '';*/

				let strParams = "jasper=LIC&typeList=criteria&attrsRepList=" + this.attrsRepList.toString() +"&attrsRepLibList=" + this.attrsRepLibList.toString() + "&strFormat=PDF"
				strParams = strParams + "&"+this.strParamsForms

				await this.$store.dispatch('axiosGet', {
					url: '/api/'+ this.instanceClassAttr.instanceClass +'/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = this.$t(this.instanceClassAttr.instanceClass +'.list')+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},
			getInstanceByIdInList(instList, instId){
				return instList.filter(item => item.id == instId)[0]
			},
			getStrLibs(instList, instListId, attrLib){
				let strLibs = ''
				instListId.forEach( (item) => {
					let instanceItem = this.getInstanceByIdInList(instList, item) 
					if(strLibs == '')
						strLibs = instanceItem[attrLib]
					else
						strLibs = strLibs + ', '+instanceItem[attrLib]
				})
				// if(strLibs != '')
				// 	strLibs = strLibs + ')'

				return strLibs?.replace('|', '-')
			},
			
		}

	}
</script>
<style scoped>
</style>